<template>
  <div>
    <action-icon
      icon="CheckSquareIcon"
      :tooltip="$t('validate')"
      @click="validate()"
    />
    <vs-popup
      :title="$t('validate_document')  | capitalize"
      :active.sync="validateModal"
      @close="closeValidateModal"
      :id="loadingPage"
      class="vs-con-loading__container"
    >
      <vs-row vs-justify="center" vs-align="center" vs-w="12" class="mb-2">
        <vs-col vs-type="flex" vs-xs="12" vs-sm="12" vs-lg="2">
          <label>{{ $t('status') }}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-xs="12" vs-sm="12" vs-lg="10">
          <div class="w-full m-2">
            <select
              v-model="validateData.status"
              class="w-full vs-inputx vs-input--input"
            >
              <option
                v-for="(option, i) in statusRequest"
                :key="i"
                :value="option.id"
              >
                {{ $t(option.name) | upperCase }}
              </option>
            </select>
          </div>
        </vs-col>
      </vs-row>
      <vs-row vs-justify="center" vs-align="center" vs-w="12" class="mb-2">
        <vs-col vs-type="flex" vs-xs="12" vs-sm="12" vs-lg="2">
          <label>{{ $t('comment') }}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-xs="12" vs-sm="12" vs-lg="10">
          <div class="w-full m-2">
            <vs-textarea
              class="w-full"
              style="resize: none;"
              autocomplete="off"
              v-model="validateData.comment"
              maxlength="250"
            />
          </div>
        </vs-col>
      </vs-row>
      <vs-row vs-justify="flex-end" vs-align="center" vs-w="12" class="mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-xs="12"
          vs-sm="2"
          vs-lg="2"
        >
          <vs-button
            color="primary"
            type="filled"
            @click="validateDocument()"
            class="w-full"
            :disabled="validateData.status == '' || validateData.comment == ''"
            >{{ $t('save') }}</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>
<script>
import loading from '@/mixins/Loading'
import repse from '../../requests/repse.js'
import ActionIcon from '@/views/qb-components/actions/ActionIcon'

export default {
  components: {
    ActionIcon,
  },
  props: {
    documentID: {
      type: String,
      default: '0',
    },
    statusRequest:{
      type: Array,
      default: () => [],
    }
  },
  computed:{
    loadingPage(){
      return 'repse-requests-validate-modal-loading' + this.documentID
    } 
  },
  data: () => ({
    validateData: {
      status: '',
      comment: '',
    },

    validateModal: false,

    
    openModalValidate: true,
  }),
  methods: {
    validate() {
      this.validateModal = true
    },
    closeValidateModal() {
      this.validateData = {
        comment: '',
        status: '',
      }
    },
    

    validateDocument: function () {
      this.openLoading(this.loadingPage)
      let data = {
        'data': this.validateData,
        'id': this.documentID
      }
      repse
        .validateDocument(data)
        .then((response) => {
          this.validateData = {
            comment: '',
            status: '',
          }
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'validated document',
          })
          this.$emit('refresh')
          this.validateModal = false
          this.closeLoading(this.loadingPage)
        })
        .catch((response) => {
          this.showValidationErrors(response)
          this.closeLoading(this.loadingPage)
        })
    },
  },

  mixins: [loading],
}
</script>
<style scoped>
</style>
